<template>
  <div>
    <!-- 修改用户信息 -->
    <i-modal :value="showModal" width="40%" class-name="vertical-center-modal" @on-cancel="cancel">
      <div slot="header" class="title">
        <h2>修改属性信息</h2>
      </div>
      <div style="text-align: center" class="modifyRole">
        <i-row class="a-row">
          <i-col span="5" offset="1">
            <span>名称：</span>
          </i-col>
          <i-col span="15">
            <i-input class="fontsize" v-model="updateName"></i-input>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="5" offset="1">
            <span class="title">简介：</span>
          </i-col>
          <i-col span="15">
            <i-input type="textarea" :rows="4" class="fontsize" v-model="updateDesc"></i-input>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="5" offset="1">
            <span class="title">类型：</span>
          </i-col>
          <i-col span="15">
            <i-input class="fontsize" v-model="updateType"></i-input>
          </i-col>
        </i-row>
      </div>
      <div slot="footer" style="text-align: center">
        <i-button type="primary" size="large" style="width: 200px" @click="submitUpdateArr">确认</i-button>
      </div>
    </i-modal>
  </div>
</template>

<script>
import { baseConfigMixin } from "../mixin"
export default {
  data() {
    return {
      updateName: "",
      updateDesc: "",
      updateType: "",
      id: "",
    }
  },
  mixins: [baseConfigMixin],
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    updateData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    cancel() {
      this.updateName = ""
      this.updateDesc = ""
      this.updateType = ""
      this.id = ""
      this.$emit("cancelModal")
    },
    async submitUpdateArr() {
      if (this.name === "") {
        this.$Message.error("属性名称不能为空")
        return
      }
      const res = await this.axios({
        method: "post",
        url: this.cmsUrl + "api/content/attribute/edit",
        data: {
          aid: this.id,
          name: this.updateName,
          desc: this.updateDesc,
          a_type: this.updateType,
        },
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        this.$Message.success("修改成功")
        this.$emit("updateList")
        this.cancel()
      } else {
        this.showLoading = false
        this.$Message.error("操作失败，错误原因：" + res.data.error_message)
      }
    },
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.updateName = this.updateData.name
        this.updateDesc = this.updateData.desc
        this.updateType = this.updateData.type
        this.id = this.updateData.id
      } else {
        this.updateName = ""
        this.updateDesc = ""
        this.updateType = ""
        this.id = ""
      }
    },
  },
}
</script>

<style lang="scss">
.title {
  text-align: center;
}
.fontsize input {
  // display: block;
  // width: 500px;
}
</style>
